import { render } from "./AwaitingOrdersList.vue?vue&type=template&id=7aff3e98&scoped=true"
import script from "./AwaitingOrdersList.vue?vue&type=script&lang=js"
export * from "./AwaitingOrdersList.vue?vue&type=script&lang=js"

import "./AwaitingOrdersList.vue?vue&type=style&index=0&id=7aff3e98&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aff3e98"]])

export default __exports__